<template>
  <div>
    <div class="header-a">
      <div class="c">
        <h3>发票类型</h3>
        <van-radio-group v-model="radio" direction="horizontal">
          <van-radio name="1" icon-size="24px" @click="bbb()">个人</van-radio>
          <van-radio name="2" icon-size="24px" @click="aaa()">企业</van-radio>
        </van-radio-group>
      </div>
      <div>
        <h3>发票抬头</h3>
        <input type="text" placeholder="请输入发票抬头" />
      </div>
      <div v-show="isshow">
        <h3>纳税识别号</h3>
        <input type="text" placeholder="请输入纳税识别号" />
      </div>
      <div>
        <h3>发票内容</h3>
        <p>停车</p>
      </div>
      <div>
        <h3>开票金额</h3>
        <p>¥10.00</p>
      </div>
      <div>
        <h3>电子邮箱</h3>
        <input type="text" placeholder="请输入电子邮箱" />
      </div>
    </div>
    <div class="btn">
      <button class="btn btn-green" @click="link('/detail')">下一步</button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      radio: "1",
      isshow: false,
    };
  },
  created() {},
  methods: {
    link(url) {
      this.$router.push(url);
    },
    aaa() {
      var radio = this.radio;
      if ((radio = 2)) {
        this.isshow = true;
      }
    },
    bbb() {
      var radio = this.radio;
      if ((radio = 1)) {
        this.isshow = false;
      }
    },
  },
};
</script>

<style scoped>
/deep/.c .van-radio__label {
  font-size: 33px;
}

.header-a {
  height: 500px;
  margin: 30px;
  background: #fff;
}

.header-a div {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 100px;
  margin: 0 40px;
}

.header-a input {
  text-align: right;
  width: 400px;
}

div h3 {
      font-size: 28px;
}

div input {
    font-size: 28px;
}

div p {
    font-size: 28px;
}

.header-a span {
  font-size: 33px;
}

.btn {
  margin-top: 400px;
}
</style>


// WEBPACK FOOTER //
// src/pages/personal.vue